module.exports = __webpack_public_path__ + "static/media/logo-inverse.ecb965f1.png";